import { useMemo } from "react";
import Plot from "react-plotly.js";

interface HeatMapProps {
  data: any[];
}

const HeatMap = ({ data }: HeatMapProps) => {

  const plotData = useMemo(() => {
    const uniqueRegionsMap: {[key: string]: { code: string, value: number }} = data.reduce(
      (uRs, datum): { code: string, value: number } => {
        if (datum.group && 'n' in datum) {
          uRs[datum.group] = {
            code: datum.group,
            value: datum.n
          }
        }
        return uRs;
      },
      {}
    );

    const locationCodes: string[] = [];
    const zValues: number[] = [];
    for (const uniqueRegion of Object.values(uniqueRegionsMap)) {
      locationCodes.push(uniqueRegion.code);
      zValues.push(uniqueRegion.value);
    }

    return [{
      type: "choropleth",
      locationmode: "USA-states",
      locations: locationCodes,
      z: zValues,
      zmin: 1,
      zmax: Math.max(...zValues),
      autocolorscale: false,
      colorscale: [
        // green log scale
        ['0', 'rgb(222,228,222)'],
        ['0.03125', 'rgb(188,201,188)'],
        ['0.0625', 'rgb(155,174,155)'],
        ['0.125', 'rgb(121,147,121)'],
        ['0.25', 'rgb(88,120,88)'],
        ['0.5', 'rgb(54,93,54)'],
        ['1', 'rgb(21,66,21)'],
      ],
      colorbar: {
        title: 'Project Count',
        thickness: 12,
      },
      marker: {
        line: {
          color: 'rgb(0,0,0)',
          width: 1,
        },
      },
    }];
  }, [data]);

  var layout = {
    geo: {
      scope: 'usa',
      showlakes: false
    },
    margin: {
      l: 40,
      r: 40,
      b: 0,
      t: 0,
    },
    autosize: true,
  };

  return (
    <Plot
      style={{
        width: "100%",
        height: "100%",
      }}
      data={plotData}
      layout={layout}
      config={{ displayModeBar: false, scrollZoom: false }}
    />
  );
};

export default HeatMap;
